import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.0612 14.5601C15.7799 14.8414 15.3983 14.9994 15.0005 14.9994H2.99952C2.60166 14.9994 2.2201 14.8414 1.93877 14.5601C1.65745 14.2788 1.4994 13.8973 1.4994 13.4995V3.74993C1.4994 3.35212 1.65745 2.97061 1.93877 2.68932C2.2201 2.40803 2.60166 2.25 2.99952 2.25H5.94726C6.19561 2.25004 6.44006 2.31173 6.65869 2.42954C6.87731 2.54735 7.06326 2.71758 7.19986 2.92497L7.8074 3.82493C7.94539 4.03445 8.13372 4.20602 8.35517 4.32394C8.57663 4.44186 8.82412 4.50235 9.07501 4.49989H15.0005C15.3983 4.49989 15.7799 4.65792 16.0612 4.93921C16.3426 5.2205 16.5006 5.60202 16.5006 5.99982V13.4995C16.5006 13.8973 16.3426 14.2788 16.0612 14.5601Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgFolder);
export default ForwardRef;
